































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';

import RoundedBox from '@/shared/components/RoundedBox/RoundedBox.vue';
import RadioBox from '@/shared/components/RadioBox/RadioBox.vue';
import LoadingBlock from '@/shared/components/LoadingBlock/LoadingBlock.vue';

import PlanLoading from './Plan/PlanLoading.vue';
import InvoiceDetailsLoading from './Invoice/InvoiceDetailsLoading.vue';

@Component({
  components: {
    RoundedBox,
    RadioBox,
    LoadingBlock,
    PlanLoading,
    InvoiceDetailsLoading,
  }
})
export default class OfferCardLoading extends Vue {
  private radioGroup: any = 0;
  private loading: boolean = true;
  private radioValue = 'true';
}
